import { DetailProductData, DetailVariationData } from "src/data/product-details/types"

export function getDefaultVariationSku(product: DetailProductData) {
  return product.variations?.find((variation) => variation.available)?.sku || product.variations?.[0]?.sku
}

export function createResolvedProductData(product: DetailProductData, variation: DetailVariationData | undefined) {
  const hasVariations = !!product.variations?.length
  const defaultVariationId = getDefaultVariationSku(product)

  if (hasVariations && !defaultVariationId) {
    throw new Error(`Could not find default variation for product "${product.name}" (${product.sku})`)
  }

  if (hasVariations && !variation) {
    throw new Error(`Could not find variation ${defaultVariationId} for product "${product.name}" (${product.sku})`)
  }

  const resolvedProduct = hasVariations ? variation! : product
  const resolvedFirstImage = resolvedProduct.images?.[0]

  if (!resolvedProduct.images?.length || !resolvedFirstImage) {
    throw new Error(`Product "${product.name}" (${product.sku}) has no images`)
  }

  if (!resolvedProduct.price) {
    throw new Error(`Product "${product.name}" (${product.sku}) has no price`)
  }

  return {
    ...product,
    product,
    variation,
    resolvedId: resolvedProduct.id,
    resolvedSku: resolvedProduct.sku,
    resolvedImages: resolvedProduct.images,
    resolvedFirstImage,
    resolvedPrice: resolvedProduct.price,
    resolvedRegularPrice: resolvedProduct.regularPrice,
    resolvedDiscount: resolvedProduct.discount,
    resolvedCoupon: resolvedProduct.coupon,
    resolvedAvailable: !!resolvedProduct.available,
    resolvedShippingDate: resolvedProduct.shippingDate,
    resolvedFreeShipping: !!resolvedProduct.freeShipping,
  }
}
